import { FullScreenSpinner, Spinner } from 'components/Elements';
import { getUser, loginWithEmailAndPassword } from 'features/auth';
import { initReactQueryAuth } from 'react-query-auth';
import Cookies from 'js-cookie';
import { REMOTE_URLS } from 'config/remotes';
import { loginWithGoogleAuthenticator } from 'features/auth/api';

export async function handleUserResponse(data) {
  const { user, authorizeDomain } = data;
  Cookies.set('token', user.token);

  if (authorizeDomain) {
    window.location.href = `${authorizeDomain}`;
  } else {
    window.location.href = `${REMOTE_URLS['finance']}`;
  }
}

async function loadUser() {
  return null;
}

async function loginFn({ data, twoFaMethod = '' }) {
  if (twoFaMethod == 'none') {
    const response = await loginWithEmailAndPassword(data);
    const user = await handleUserResponse(response);
    return user;
  } else if (twoFaMethod == 'email') {
    return await verifyEmailOTPLogin(data);
  } else if (twoFaMethod == 'google') {
    return await loginWithGoogleAuthenticator(data);
  }
}

async function logoutFn() {
  Cookies.remove('token');
  Cookies.remove('identity_verified');
  window.location.assign(window.location.origin);
}

const authConfig = {
  loadUser,
  loginFn,

  logoutFn,
  LoaderComponent() {
    return (
      <div>
        <FullScreenSpinner />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth(authConfig);
